import { FaTimes } from "react-icons/fa";

export default function Modal({ open, title, children, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/60 p-4" role="dialog" aria-modal="true" aria-label={title}>
      <div className="w-full max-w-xl rounded-xl bg-white shadow-lift">
        <div className="flex items-center justify-between border-b border-line px-5 py-4">
          <h2 className="text-xl font-semibold text-dark">{title}</h2>
          <button onClick={onClose} className="grid h-10 w-10 place-items-center rounded-xl border border-line text-dark hover:text-primary" aria-label="Close modal"><FaTimes /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
